export enum FeatureFlag {
    IS_RECALL_ENABLED = 'isRecallEnabled',
    IS_CAREVIEW_ENABLED = 'isCareViewEnabled',
    IS_PATIENTVIEW_ENABLED = 'isPatientViewEnabled',
    IS_CONNECT_ENABLED = 'isConnectEnabled',
    IS_CONNECT_CALENDAR_ENABLED = 'isConnectCalendarEnabled',
}

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlag, boolean> = {
    [FeatureFlag.IS_RECALL_ENABLED]: false,
    [FeatureFlag.IS_CAREVIEW_ENABLED]: false,
    [FeatureFlag.IS_PATIENTVIEW_ENABLED]: false,
    [FeatureFlag.IS_CONNECT_ENABLED]: false,
    [FeatureFlag.IS_CONNECT_CALENDAR_ENABLED]: false,
};
